var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 41,
    viewBox: "0 0 31 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0242 38.3396C24.3182 30.893 22.5204 21.5217 15.7492 16.0585C15.7452 16.0554 15.7413 16.0515 15.7381 16.0492L15.7674 16.1203L15.7626 16.1736C17.0819 19.5778 16.8968 23.315 15.2762 26.5214L14.1341 28.7821L13.7837 26.2842C13.5456 24.5898 12.8915 22.9735 11.8838 21.5897H11.7248L11.641 21.3579C11.6529 23.947 11.0945 26.4975 9.999 28.9034C8.56186 32.0519 8.77304 35.6825 10.5645 38.6169L11.8008 40.6428L9.57664 39.7249C5.90904 38.2113 2.97701 35.2954 1.53196 31.7251C-0.0871038 27.7383 0.212664 23.1157 2.33476 19.3622C3.44129 17.4098 4.21642 15.3368 4.63957 13.1997L5.05324 11.1051L6.10835 12.9733C6.61219 13.8642 6.98314 14.8284 7.2133 15.8413L7.23703 15.8653L7.26155 16.0276L7.28449 16.0206C10.4451 11.9187 12.3386 6.81471 12.6147 1.64659L12.6858 0.307617L13.8359 1.04007C18.5293 4.02783 21.7888 8.82123 22.7957 14.2072L22.8186 14.3177L22.8305 14.3347L22.8819 14.2636C23.8018 13.0769 24.2874 11.6653 24.2874 10.1795V7.87862L25.7087 9.71285C29.0133 13.9762 30.7075 19.2649 30.4797 24.6053C30.1997 30.8914 26.6903 36.4088 21.0912 39.3981L18.667 40.6922L20.0242 38.3396Z",
    fill: "#FE5303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire_icon.2523fc920731c7dc8c932cdd2a97f23d.svg";
export { ForwardRef as ReactComponent };